import { bootstrapApplication } from '@angular/platform-browser';
import { bootstrapLeerplus } from '@gametailors/leerplus';
import { App } from './app/app';
import { appConfig } from './app/app.config';

bootstrapApplication(App, appConfig)
  .then((appRef) => {
    bootstrapLeerplus(appRef);
  })
  .catch((err) => console.error(err));
